import { RESPONSE_OF_UNPROCESSED_DATA_FOR_LEGAL_MODERATION, RESPONSE_POST_PROCESSED_LEGAL_DATA_TO_SERVER,
        RESPONSE_OF_UNPROCESSED_DATA_FOR_ADDITIONAL_LEGAL_MODERATION, RESPONSE_POST_PROCESSED_ADDITIONAL_LEGAL_DATA_TO_SERVER,RESPONSE_UPLOAD_LEGAL_BULK_DELETE_EXCEL,SET_EXCEL_DOWNLOADING   } from './action';


const legalModerationReducer = (state={isExcelDownloading: false }, action) => {
    switch (action.type) {
        case RESPONSE_OF_UNPROCESSED_DATA_FOR_LEGAL_MODERATION:
            return state = {
                ...state,
                legalUnprocessedData: action.data.data
            }

        case RESPONSE_POST_PROCESSED_LEGAL_DATA_TO_SERVER:
            return state = {
                ...state,
                legalProcessedData: action.data
            }
        
        case RESPONSE_OF_UNPROCESSED_DATA_FOR_ADDITIONAL_LEGAL_MODERATION:
        return state = {
            ...state,
            additionalLegalUnprocessedData: action.data.data
        }

        case RESPONSE_POST_PROCESSED_ADDITIONAL_LEGAL_DATA_TO_SERVER:
            return state = {
                ...state,
                additionalLegalProcessedData: action.data
            }
        case RESPONSE_UPLOAD_LEGAL_BULK_DELETE_EXCEL:
            return state = {
                ...state,
                uploadBulkDeleteExcelResponse: action.data
            }
            case SET_EXCEL_DOWNLOADING:
            return {
                ...state,
                isExcelDownloading: action.payload
            }
        default: return state
    }
}


export default legalModerationReducer;